import {
    APP_INIT,
    APP_LOADED,
    APP_SETTINGS_SUCCESS,
    MODAL_HIDE,
    MODAL_SHOW,
    SNACKBAR_HIDE,
    SNACKBAR_SHOW,
    SIDE_NAV_SHOW,
    SIDE_NAV_TYPE,
    SET_APP_INFO,
    UPDATE_ENV,
} from "types";

import { AnyAction } from "redux";

import { rs } from "helpers/reducers";

interface IState {
    environments: any[];
    loaded: boolean;
    modals: Array<{
        id: string;
    }>;
    request: any;
    settings: any;
    snackbar: any;
    sideNavShow: boolean;
    sideNavType: string;
}
function general(
    state: IState = {
        environments: [],
        loaded: false,
        modals: [],
        request: {},
        settings: {},
        snackbar: null,
        sideNavShow: false,
        sideNavType: "main",
    },
    action = {} as AnyAction
) {
    switch (action.type) {
        case APP_INIT:
            return rs.init(state);

        case APP_LOADED:
            return {
                ...state,
                loaded: true,
            };

        case APP_SETTINGS_SUCCESS:
            const data = action.response.data.data;
            return {
                ...state,
                settings: data,
                environments: Object.entries(data.projects).map(
                    ([module, environments]) => {
                        return {
                            module,
                            env: Object.keys(environments as any)[0],
                        };
                    }
                ),
            };

        case MODAL_HIDE:
            return {
                ...state,
                modals: state.modals.filter((modal) => modal.id !== action.id),
            };

        case MODAL_SHOW:
            return {
                ...state,
                modals: [
                    ...state.modals,
                    {
                        id: action.id,
                        props: action.props,
                    },
                ],
            };

        case SET_APP_INFO:
            return {
                ...state,
                info: action.info,
            };

        case SNACKBAR_HIDE:
            return {
                ...state,
                snackbar: null,
            };
        case SNACKBAR_SHOW:
            return {
                ...state,
                snackbar: action.data,
            };

        case SIDE_NAV_SHOW:
            return {
                ...state,
                sideNavShow: action.data,
            };
        case SIDE_NAV_TYPE:
            return {
                ...state,
                sideNavType: action.data,
            };
        case UPDATE_ENV:
            return {
                ...state,
                environments: state.environments.map((item: any) =>
                    item.module === action.data.module
                        ? { ...item, env: action.data.env }
                        : item
                ),
            };
        default:
            return state;
    }
}

export default general;
